<template>
  <div>
    <div class="spaceBetween" style="margin-bottom:0.32rem;align-items:end">
      <div class="spaceLeft">
        <!-- 左侧空间，与detail.vue保持一致 -->
      </div>
      <!-- <div class="spaceLeft search-form">
        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.loanId" placeholder="No..." suffix-icon="el-icon-search" @change="getList" />
        </div>
        <search-date @dateChange="dateChange($event, 'repayTime')" label="Repayment time" style="margin-left: 0.2rem;" />
      </div> -->
    </div>
    
    <el-table class="common-table" :data="tableList" v-loading="loading">
      <el-table-column prop="timestamp" label="Repayment time" align="left">
        <template slot-scope="{ row }">
          {{ moment(row.timestamp * 1000).format("YYYY.MM.DD HH:mm") }}
        </template>
      </el-table-column>
      <el-table-column prop="loanId" label="Borrow No." align="left">
        <template slot-scope="{ row }">
          <span class="loan-id-link" @click="goToBorrowDetail(row.loanId)">{{ row.loanId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="repayAmount" label="Repayment amount" align="right">
        <template slot-scope="{ row }">
          <big-number :number="row.repayAmount" :decimals="2" />
          <span class="td-word-sm">TCash</span>
        </template>
      </el-table-column>
      <el-table-column prop="unitAmount" label="Collateral released" align="right">
        <template slot-scope="{ row }">
          <big-number :number="row.unitAmount" :decimals="2" />
          <span class="td-word-sm">UNIT</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
      @pagination="getList()" />
  </div>
</template>

<script>
import { getRepayList } from "@/api/ustn/loan.js";
export default {
  components: {},
  props: {
    searchParams: {
      type: Object,
      default: () => ({
        loanId: undefined,
        startTime: undefined,
        endTime: undefined
      })
    }
  },
  data() {
    return {
      loading: false,
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
    };
  },
  computed: {},
  methods: {
    dateChange(val, type) {
      if (val) {
        this.searchParams.startTime = val[0];
        this.searchParams.endTime = val[1]; 
      } else {
        this.searchParams.startTime = undefined;
        this.searchParams.endTime = undefined;
      }
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const res = await getRepayList({
          borrower: this.$store.getters.metaMaskObj.account,
          page: this.queryParams.page,
          pageSize: this.queryParams.pageSize,
          loanId: this.searchParams.loanId,
          startTime: this.searchParams.startTime,
          endTime: this.searchParams.endTime
        });
        this.tableList = res.result.list || [];
        this.queryParams.total = res.result.total || 0;
      } catch (err) {
        console.error('获取列表失败:', err);
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.getList();
    },
    goToBorrowDetail(loanId) {
      this.$router.push({
        path: "/TCashFinance/lending/detail",
        query: {
          loanId: loanId
        }
      });
    },
  },
  created() {
    this.getList();
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.getList();
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">
.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}

.loan-id-link {
  color: rgba(34, 91, 252, 1);
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.search-form {
  justify-content: flex-end;
  
  >>>.el-input__inner {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  
  >>>.el-range-editor.el-input__inner {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  
  >>>.el-date-editor .el-range-separator {
    color: rgba(255, 255, 255, 0.7);
  }
  
  >>>.el-date-editor .el-range-input {
    color: #fff;
    background-color: transparent;
  }
}

.common-card.is-border .common-card-main {
  padding: 0.26rem 0;
}

.exchange-tab-box {
  border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
  padding: 0;
  position: relative;
}

.exchange-tab-body {
  padding: 0.38rem 0.4rem 0 0.4rem;
}

/deep/ .el-tabs {
  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__nav {
    width: 100%;

    .el-tabs__item {
      font-size: 0.22rem;
      color: #929dad;
      padding: 0 0.4rem 0.26rem 0.4rem;
      height: auto;
      text-align: center;

      &.is-active {
        color: #3172fd;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
      }
    }
  }

  .el-tabs__nav-wrap::after {
    height: 0;
  }
}

.common-table {
  >>>.el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>>.el-loading-spinner .path {
    stroke: #2675f1;
  }
}
</style>
